// Pytania i odpowiedzi: odpowiedź rozwija się i zwija płynnie zamiast skakać (bez JS działa zwykłe <details>).
import {gsap, ScrollTrigger, $$} from "./shared";

export function initFaq() {
    $$("details.cc-faq__item").forEach((details) => {
        const summary = details.querySelector("summary");
        const answer = details.querySelector(".cc-faq__a");
        if (!summary || !answer) {
            return;
        }
        const done = () => {
            details.classList.remove("is-closing", "is-animating");
            gsap.set(answer, {clearProps: "height,paddingBottom,opacity,visibility,overflow"});
            ScrollTrigger.refresh();
        };

        summary.addEventListener("click", (event) => {
            event.preventDefault();
            if (details.classList.contains("is-animating")) {
                return;
            }
            details.classList.add("is-animating");

            if (details.open) {
                details.classList.add("is-closing");
                gsap.to(answer, {
                    height: 0,
                    paddingBottom: 0,
                    autoAlpha: 0,
                    overflow: "hidden",
                    duration: 0.35,
                    ease: "power2.inOut",
                    onComplete: () => {
                        details.open = false;
                        done();
                    }
                });
                return;
            }

            details.open = true;
            const padding = gsap.getProperty(answer, "paddingBottom");
            gsap.fromTo(answer,
                {height: 0, paddingBottom: 0, autoAlpha: 0, overflow: "hidden"},
                {height: "auto", paddingBottom: padding, autoAlpha: 1, duration: 0.55, ease: "power3.out", onComplete: done}
            );
        });
    });
}
